import { OENCommand } from "../enums/oe-command.enum";

/**
 * BfxOrderEntryCmdEvent
 * ----------------------------------
 * This model is used for dissemination of commands from the _oeCoordinator service
 * to the order entry interface panels and screen.
 */
export class OECommandEventModel {
  // must
  public ref: string;
  public cmd: OENCommand;
  public data: any;

  constructor(_ref: string, _cmd: OENCommand, _data?: any) {
    this.ref = _ref;
    this.cmd = _cmd;
    this.data = _data != null ? _data : null;
  }
}
